exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/index.css
// module id = 1161
// module chunks = 0